import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

if (ElementUI.Dialog && ElementUI.Dialog.props) {
  ElementUI.Dialog.props.appendToBody.default = true;
  ElementUI.Dialog.props.closeOnClickModal.default = false;
}

Vue.use(ElementUI);
Vue.use(VueQuillEditor);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
